import React, { createContext, useContext, useState } from 'react';
import { uploadChunksWeb, comitChunksWeb } from './web_upload_chunks';
import { EventNoteAllApi } from "../../apis/notification/event_note_all";
import { PostNoteAllApi } from "../../apis/notification/post_note_all";

const UploadContext = createContext();

export const UploadProvider = ({ children }) => {
    const [uploads, setUploads] = useState({});

    const startBackgroundUpload = async ({ eventId, selFiles, publishType,setUploadStatus }) => {
        setUploads(prev => ({
            ...prev,
            [eventId]: { progress: 0, status: 'uploading', totalFiles: selFiles.length }
        }));

        try {
            for (let i = 0; i < selFiles.length; i++) {
                const file = selFiles[i];
                const isVideo = file.type.startsWith('video');
                const mediaType = isVideo ? 'video' : 'image';

                const uploadRes = await uploadChunksWeb(
                    eventId,
                    file,
                    (progress) => {
                        setUploadStatus(prev => ({ ...prev, progress: Math.round(progress) }));
                        const overallProgress = Math.round(((i + progress / 100) / selFiles.length) * 100);
                        setUploads(prev => ({
                            ...prev,
                            [eventId]: { ...prev[eventId], progress: overallProgress }
                        }));
                    },
                    publishType
                );

                const cropData = {
                    index: i,
                    cropFrame: { x: 0, y: 0, width: 1, height: 1, scale: 1, rotation: 0 },
                    aspectRatio: 1,
                    filter: 'normal',
                    lockedAspectRatio: 1
                };

                const commitPayload = {
                    eventId,
                    uploadId: uploadRes.uploadId,
                    totalChunks: uploadRes.totalChunks,
                    fileName: file.name,
                    cropData,
                    type: mediaType
                };

                await comitChunksWeb(commitPayload, publishType);
            }

            setUploads(prev => ({
                ...prev,
                [eventId]: { progress: 100, status: 'completed' }
            }));

            if (publishType === "event") {
                EventNoteAllApi(eventId);
            } else {
                PostNoteAllApi(eventId);
            }

        } catch (error) {
            console.error("Background upload error:", error);
            setUploads(prev => ({
                ...prev,
                [eventId]: { status: 'failed', error: error.message }
            }));
        }
    };

    return (
        <UploadContext.Provider value={{ uploads, startBackgroundUpload }}>
            {children}
        </UploadContext.Provider>
    );
};

export const useUpload = () => useContext(UploadContext);